import React from 'react';
import Head from 'next/head';
import Intro from '.././../components/Intro';
const PrivacyPolicy = props => {
  return (
    <>
      <Head>
        <title>Privacy Policy - Prodigi Marketing Agency</title>
        <meta
          name="description"
          content="Learn how Prodigi collects, uses, and protects your personal information. Read our comprehensive privacy policy for complete details."
        />
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/privacy-policy" />
      </Head>
      <style jsx global>
        {`
          .pt-20 {
            padding-top: 20px;
          }
          @media screen and (max-width: 400px) {
            .p-items {
              padding: 0 20px 20px 20px;
            }
            .pt-mobile {
              padding-top: 20px;
            }
          }
        `}
      </style>
      <Intro title="We Value" referrer="privacy" subTitles="Your Privacy" width={props.width} />
      <div className="container p-items  pt-20 pt-mobile  text-16 leading-20 ">
        At WeProdigi, accessible from{' '}
        <a className="text-purple underline" href="https://weprodigi.com/">
          https://weprodigi.com/
        </a>
        , one of our main priorities is the privacy of our visitors. This Privacy Policy document contains types of information that are collected and
        recorded by WeProdigi and how we use it. If you have additional questions or require more information about our Privacy Policy, do not
        hesitate to contact us. <br />
        This Privacy Policy applies only to our online activities and is valid for visitors to our website about the information that they share
        and/or collect in WeProdigi. This policy does not apply to any information collected offline or via channels other than this website.
      </div>
      <div className="container p-items pt-20 ">
        <div className="text-purple  font-bolder">CONSENT</div>
        <div className="text-16 leading-20  pt-20">By using our website, you hereby consent to our Privacy Policy and agree to its terms.</div>
      </div>
      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">INFORMATION WE COLLECT</div>
        <div className="text-16 leading-20  pt-20">
          The personal information that you are asked to provide, and the reasons why you are asked to provide it, will be made clear to you at the
          point we ask you to provide your personal information.
          <br />
          If you contact us directly, we may receive additional information about you such as your name, email address, phone number, the contents of
          the message and/or attachments you may send us, and any other information you may choose to provide.
          <br />
          When you register for an Account, we may ask for your contact information, including items such as name, company name, address, email
          address, and telephone number.
        </div>
      </div>
      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">HOW WE USE YOUR INFORMATION</div>
        <div className="text-16 leading-20  pt-20">
          We use the information we collect in various ways, including:
          <ul className="list-outside list-disc mt-20 pl-20">
            <li>Provide, operate, and maintain our website</li>
            <li>Improve, personalize, and expand our website </li>
            <li>Understand and analyze how you use our website </li>
            <li>Develop new products, services, features, and functionality</li>
            <li>
              Communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and
              other information relating to the website, and for marketing and promotional purposes
            </li>
            <li>Send you emails</li>
            <li>Find and prevent fraud</li>
          </ul>
        </div>
      </div>
      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">LOG FILES</div>
        <div className="text-16 leading-20  pt-20">
          Prodigi follows a standard procedure of using log files. These files log visitors when they visit websites. All hosting companies do this
          and are a part of hosting services' analytics. The information collected by log files includes internet protocol (IP) addresses, browser
          type, Internet Service Provider (ISP), date and time stamp, referring/exit pages, and possibly the number of clicks. These are not linked to
          any personally identifiable information. The purpose of the information is to analyze trends, administer the site, track users' movement on
          the website, and gather demographic information.
        </div>
      </div>

      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">COOKIES AND WEB BEACONS</div>
        <div className="text-16 leading-20  pt-20">
          Like any other website, WeProdigi uses 'cookies'. These cookies are used to store information including visitors' preferences, and the pages
          on the website that the visitor accessed or visited. The information is used to optimize the users' experience by customizing our web page
          content based on visitors' browser type and/or other information.
          <br />
          For more general information on cookies, please read
          <a href="https://www.cookieconsent.com/what-are-cookies/" className="text-green underline">
            "What Are Cookies".
          </a>
        </div>
      </div>

      <div className="container  p-items  pt-20  ">
        <div className="text-purple  font-bolder">OUR ADVERTISING PARTNERS</div>
        <div className="text-16 leading-20  pt-20">
          Some of the advertisers on our site may use cookies and web beacons. Our advertising partners are listed below. Each of our advertising
          partners has its own Privacy Policy for their policies on user data. For easier access, we hyperlinked to their Privacy Policies below.
          <ul className="list-outside list-disc mt-20 pl-20">
            <li>
              {' '}
              Google <br />
              <a className="text-green underline break-all" href="https://policies.google.com/technologies/ads">
                https://policies.google.com/technologies/ads
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">ADVERTISING PARTNERS PRIVACY POLICIES</div>
        <div className="text-16 leading-20  pt-20">
          You may consult this list to find the Privacy Policy for each of the advertising partners of WeProdigi.
          <br />
          Third-party ad servers or ad networks use technologies like cookies, JavaScript, or Web Beacons that are used in their respective
          advertisements and links that appear on WeProdigi, which are sent directly to users' browsers. They automatically receive your IP address
          when this occurs. These technologies are used to measure the effectiveness of their advertising campaigns and/or to personalize the
          advertising content that you see on websites that you visit.
          <br />
          Note that WeProdigi has no access to or control over these cookies that are used by third-party advertisers.
        </div>
      </div>

      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">THIRD PARTY PRIVACY POLICIES</div>
        <div className="text-16 leading-20  pt-20">
          WeProdigi's Privacy Policy does not apply to other advertisers or websites. Thus, we are advising you to consult the respective Privacy
          Policies of these third-party ad servers for more detailed information. It may include their practices and instructions about how to opt out
          of certain options. <br />
          You can choose to disable cookies through your individual browser options. To know more detailed information about cookie management with
          specific web browsers, it can be found at the browsers' respective websites.
        </div>
      </div>

      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">CCPA PRIVACY RIGHTS (DO NOT SELL MY PERSONAL INFORMATION)</div>
        <div className="text-16 leading-20  pt-20">
          Under the CCPA, among other rights, California consumers have the right to:
          <ul className="list-outside list-disc mt-20 pl-20">
            <li>
              Request that a business that collects a consumer's data disclose the categories and specific pieces of personal data that a business has
              collected about consumers.
            </li>
            <li>Request that a business delete any personal data about the consumer that a business has collected. </li>
            <li>Request that a business that sells a consumer's personal data, not sell the consumer's personal data.</li>
            <li>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</li>
          </ul>
        </div>
      </div>

      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">GDPR DATA PROTECTION RIGHTS</div>
        <div className="text-16 leading-20  pt-20">
          We would like to make sure you are fully aware of all of your data protection rights. Every user is entitled to the following:
          <ul className="list-outside list-disc mt-20 pl-20">
            <li>The right to access – You have the right to request copies of your data. We may charge you a small fee for this service.</li>
            <li>
              The right to rectification – You have the right to request that we correct any information you believe is inaccurate. You also have the
              right to request that we complete the information you believe is incomplete.{' '}
            </li>
            <li>The right to erasure – You have the right to request that we erase your data, under certain conditions.</li>
            <li>
              The right to restrict processing – You have the right to request that we restrict the processing of your data, under certain conditions.
            </li>
            <li>
              The right to object to processing – You have the right to object to our processing of your personal data, under certain conditions.
            </li>
            <li>
              The right to data portability – You have the right to request that we transfer the data that we have collected to another organization,
              or directly to you, under certain conditions.
            </li>
            <li>If you make a request, we have one month to respond to you. If you would like to exercise any of these rights, please contact us.</li>
          </ul>
        </div>
      </div>

      <div className="container  p-items    pt-20  ">
        <div className="text-purple  font-bolder">CHILDREN'S INFORMATION</div>
        <div className="text-16 leading-20  pt-20 pb-30">
          Another part of our priority is adding protection for children while using the internet. We encourage parents and guardians to observe,
          participate in, and/or monitor and guide their online activity.
          <br />
          WeProdigi does not knowingly collect any Personal Identifiable Information from children under the age of 13. If you think that your child
          provided this kind of information on our website, we strongly encourage you to contact us immediately and we will do our best efforts to
          promptly remove such information from our records.
        </div>
      </div>
    </>
  );
};
export default PrivacyPolicy;
